var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"right-menu"},[_c('li'),(_vm.userIsProfessional || _vm.userIsCompany)?_c('menu-config-professional'):_vm._e(),(_vm.user.type === 'patient')?_c('menu-config'):_vm._e(),_c('menu-user')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357a27d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/headers/toolbar.vue
// module id = weUT
// module chunks = 110